import Vue from 'vue';
import Vuex from 'vuex';

import global from './global';
import auth from './auth';
import user from './user';
import token from './token';
import role from './role';
import permissions from './permissions';
import country from './country';
import shop from './shop';
import device from './device';
import shopGroup from './shop-group';
import tenant from './tenant';
import company from './company';
import uiPermissions from './ui-permissions';
import audit from './audit';
import firewall from './firewall';
import entityLog from './entity-log';
import liabilityCounter from './liability-counter';
import lotterySystem from './lottery-system';
import lotteryEvent from './lottery-event';
import ticket from './ticket';
import player from './player';
import onlinePlayer from './online-player';
import thirdPartyPlayer from './third-party-player';
import terminal from './terminal';
import cache from './cache';
import cacheOnDemand from './cache-on-demand';
import registry from './registry';
import lotteryTicketAuthorization from './lottery-ticket-authorization';
import cashResult from './reports/cash-result';
import expiredWinning from './reports/expired-winning';
import lotteryOffer from './reports/lottery-offer';
import lotteryResult from './reports/lottery-result';
import lotterySystemPerformance from './reports/lottery-system-performance';
import returnPlayer from './reports/return-player';
import taxedPaidTicket from './reports/taxed-paid-ticket';
import product from './product';
import ws from "./ws";
import incomePayments from './genreports/income-payment';
import deviceIncomePayments from './genreports/device-income-payment';
import cashRegister from './genreports/cash-register';
import dmIncome from './genreports/daily-monthly-income';
import receiptsWinnings from './genreports/receipts-winnings';
import cashRequired from './genreports/cash-required';
import manualReport from './genreports/manual-report';
import bank from './bank';
import operator from './operator';
import subtype from './subtype';
import slot from './slot';
import slotReport from './slot-report';
import shopBalance from './genreports/shop-balance';
import shopBalanceTX from './genreports/shop-balance-tx';
import shopCashTX from './shop-cash-tx';
import onlineCashTX from './online-cash-tx';
import shopEposTX from "./shop-epos-tx";
import apiImports from './genreports/api-imports';
import imageUpload from './image-upload';
import userActivity from './user-activity';
import terminalActivity from './terminal-activity';
import userClocking from './user-clocking';
import userActivityManual from './user-activity-manual';
import userClockingManual from './user-clocking-manual';
import operatorsReport from './genreports/operators-report';
import onlinePayouts from './genreports/online-payouts';
import jackpotHistory from './jackpot-history';
import raffle from './raffle';
import shopVisits from './shop-visits';

import jackpot from './jackpot';

import {
  abilityPlugin,
  ability as appAbility
} from './ui-permissions/ability';

Vue.use(Vuex);

const ability = appAbility;
window._ability = ability;

const store = new Vuex.Store({
  plugins: [
    abilityPlugin
  ],
  modules: {
    global,
    auth,
    uiPermissions,
    user,
    token,
    role,
    permissions,
    country,
    lotterySystem,
    shop,
    device,
    shopGroup,
    tenant,
    company,
    audit,
    firewall,
    entityLog,
    liabilityCounter,
    lotteryEvent,
    ticket,
    player,
    onlinePlayer,
    thirdPartyPlayer,
    terminal,
    cache,
    cacheOnDemand,
    registry,
    lotteryTicketAuthorization,
    cashResult,
    expiredWinning,
    lotteryOffer,
    lotteryResult,
    lotterySystemPerformance,
    returnPlayer,
    taxedPaidTicket,
    product,
    ws,
    incomePayments,
    deviceIncomePayments,
    dmIncome,
    cashRegister,
    receiptsWinnings,
    bank,
    operator,
    subtype,
    slot,
    slotReport,
    shopBalance,
    shopBalanceTX,
    shopCashTX,
    onlineCashTX,
    shopEposTX,
    cashRequired,
    apiImports,
    imageUpload,
    userActivity,
    terminalActivity,
    userClocking,
    manualReport,
    userActivityManual,
    userClockingManual,
    jackpot,
    operatorsReport,
    jackpotHistory,
    raffle,
    shopVisits,
    onlinePayouts,
  },
});

export {
  ability,
  store
};

export default store;
